import { Alert } from "antd";
import { useEffect, useState } from "react";
import styles from "./styles.module.scss";
import { EditOutlined } from "@ant-design/icons";
import TextArea from "antd/es/input/TextArea";
import { Button } from "../Button";
import { TextWithTooltip } from "../TextWithTooltip";

interface Note {
  value: string;
  isSubmiting: boolean;
  handleSubmit: (value: string) => void;
  title?: string;
}

export function Notes({ isSubmiting, value, handleSubmit, title }: Note) {
  const [noteValue, setNoteValue] = useState(value);

  const [isEditing, setIsEditing] = useState(false);
  useEffect(() => {
    setNoteValue(noteValue);
  }, [value]);

  useEffect(() => {
    if (!isSubmiting) {
      setIsEditing(false);
    }
  }, [isSubmiting]);

  useEffect(() => {
    if (!isEditing) {
      setNoteValue(value);
    }
  }, [isEditing]);

  return (
    <Alert
      message={title || "Notes"}
      type="info"
      showIcon
      action={
        isEditing ? undefined : (
          <EditOutlined
            className={styles.icon}
            onClick={() => setIsEditing(true)}
          />
        )
      }
      description={
        !isEditing ? (
          <TextWithTooltip text={noteValue} limit={500} />
        ) : (
          <div className={styles.container}>
            <TextArea
              value={noteValue}
              onChange={(e) => setNoteValue(e.target.value)}
            />
            <div className={styles.footer}>
              <Button
                size="small"
                onClick={() => {
                  setIsEditing(false);
                }}
              >
                Cancel
              </Button>
              <Button
                type="primary"
                size="small"
                loading={isSubmiting}
                onClick={() => {
                  handleSubmit(noteValue);
                }}
              >
                Apply
              </Button>
            </div>
          </div>
        )
      }
    />
  );
}
